import http from 'config/http';

import { NotificationModel } from 'api/models';
import { getApiUrl } from 'config/api-url';

export const getUnreadNotificationCount = async () => {
    const { data } = await http.get(`${getApiUrl()}/notifications/unread/count`);

    return data as { count: number };
};

export const getAllNotifications = async (queryParams: { offset: number; limit: number }) => {
    const { data } = await http.get(`${getApiUrl()}/notifications`, { params: queryParams });

    const result = {
        count: data.count,
        notifications: NotificationModel.fromObjectList(data.notifications),
    };

    return result as { count: number; notifications: NotificationModel[] };
};

export const readNotificationsByIds = async (notificationIds: string[]) => {
    await http.post(`${getApiUrl()}/notifications/read`, { notificationIds });
};

export const readAllNotifications = async () => {
    await http.post(`${getApiUrl()}/notifications/read-all`);
};
